import React from 'react';
import { LocationProvider } from '@reach/router';

import '../ui/global';

export const wrapRootElement = ({ element, ...rest }) => {
	return <LocationProvider>{element}</LocationProvider>;
};
